import React, { memo } from 'react'
import map from 'ramda/src/map'
import head from 'ramda/src/head'
import Slider from 'root/src/client/web/base/Slider'
import length from 'ramda/src/length'
import classNames from 'classnames'
import ProjectVideoCard from 'root/src/client/web/list/listItemComponents/ProjectVideoCard'
import LoadingProgress from 'root/src/client/web/list/LoadingProgress'
import withStyles from '@material-ui/core/styles/withStyles'
import useScript from 'root/src/client/web/hooks/useScript'
import { ytPlayerSrc, twitchPlayerSrc, facebookPlayerSrc } from 'root/src/shared/constants/playerUrls'
import renderCascadedSliderItems from 'root/src/client/util/renderCascadedSliderItems'
import { videoCardListStyle } from './style'

const VideoCardList = ({
	button, isMobileRes, list, visibleLoadingBlock,
	sliderShowItems, layoutRow, classes, ...props
}) => {
	const [ytLoaded] = useScript(ytPlayerSrc)
	const [twitchPlayerLoaded] = useScript(twitchPlayerSrc)
	const [facebookPlayerLoaded] = useScript(facebookPlayerSrc)

	return (
		<div
			className={classNames(
				classes.root,
			)}
		>
			{length(head(list)) > 0
			&& ytLoaded
			&& twitchPlayerLoaded
			&& facebookPlayerLoaded
				? (
					<Slider
						infinite
						arrows
						renderSliderItem={renderCascadedSliderItems}
						isMobileRes={isMobileRes}
						intervalDuration={320}
						startItem={Math.floor(sliderShowItems / 2)}
						showItems={isMobileRes ? 1 : sliderShowItems}
						sliderItemsStyle={classes.sliderItemsStyle}
						layoutRow={layoutRow}
						arrowWidth={85}
						{...props}
					>
						{map(recordId => (
							<ProjectVideoCard
								recordId={recordId}
								autoplay
								muted={false}
								key={recordId}
							/>
						), list)}
					</Slider>
				)
				:	<LoadingProgress loading={visibleLoadingBlock} />}
		</div>

	)
}

export default withStyles(videoCardListStyle, { name: 'MuiVideoCardList' })(memo(VideoCardList))
